import { UI_PTIMITIVE__card } from '@/components/ui/card/UI_PTIMITIVE__card';
import { EZIndexes } from '@/enums/EZIndexes';
import { use_slice_ui } from '@/hooks/store/use_slices';
import i18n_page_auth from '@/locales/keys/i18n_page_auth.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { useTranslation } from 'react-i18next';
import { UI_PRIMITIVE__card_header } from '../../components/ui/card/card';
import { LAYOUT_PAGE__recent_images_grid } from '../_base/layouts/LAYOUT_PAGE__recent_images_grid';
import { A_LAYOUT__email_not_verified } from './views/A_LAYOUT__email_not_verified';
import { ViewEnterWithEmail } from './views/ViewEnterWithEmail';
import { ViewEnterWithSocialNetworks } from './views/ViewEnterWithSocialNetworks';
import { ViewMagicLinkSent } from './views/ViewMagicLinkSent';

export function A_PAGE_LAYOUT__desktop() {
  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_AUTH);

  const { page_auth_show_email_is_not_verified, page_auth_show_magic_link_sent } = use_slice_ui([
    'page_auth_show_email_is_not_verified',
    'page_auth_show_magic_link_sent',
  ]);

  /*
   *
   */
  function render_view_desktop() {
    if (page_auth_show_email_is_not_verified) {
      return <A_LAYOUT__email_not_verified />;
    } else if (page_auth_show_magic_link_sent) {
      return <ViewMagicLinkSent />;
    } else {
      return (
        <div className="w-[46rem] h-[21rem] flex items-center justify-center animation-gradient-gray rounded-for-gradient-1">
          <UI_PTIMITIVE__card className={`w-[100%-4px] h-[100%-4px] bg-component border-component-border ${EZIndexes.Z_2}`}>
            <UI_PRIMITIVE__card_header className="px-16 pt-6 pb-8 ">
              <div className="grid grid-cols-2 gap-[8rem]">
                <ViewEnterWithEmail />
                <ViewEnterWithSocialNetworks />
                <div className="pointer-events-none absolute top-0 bottom-0 left-1/2 w-[1px] bg-component-border" />
                <div className="pointer-events-none absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-8 h-8 bg-component rounded-full border border-component-border text-sm text-center text-white flex items-center justify-center">
                  <span className="text-bar-foreground h-[10px] flex items-center justify-center mb-0.5">
                    {t(i18n_page_auth.auth_component.base.login_choice_placeholder).toUpperCase()}
                  </span>
                </div>
              </div>
            </UI_PRIMITIVE__card_header>
          </UI_PTIMITIVE__card>
        </div>
      );
    }
  }

  return <LAYOUT_PAGE__recent_images_grid>{render_view_desktop()}</LAYOUT_PAGE__recent_images_grid>;
}
